import { registerSync, Sync, Color } from 'olympe';


/**
 * @extends {olympe.dc.Sync}
 */
export class ChartsData extends Sync {

    /**
     * @return {string|Date}
     */
    getLabel() {
        return this.db.getProperty(this.tag, ChartsData.labelProp);
    }

    /**
     * @return {number}
     */
    getNumber() {
        return this.db.getProperty(this.tag, ChartsData.numberProp);
    }

    /**
     * @return {Color}
     */
    getColor() {
        return this.db.getProperty(this.tag, ChartsData.colorProp);
    }
}

// Hardcoded tags
ChartsData.entry = registerSync('017aafb0ef28babd36bd', ChartsData);
ChartsData.labelProp = ChartsData.entry.addProperty('017aafc133d7a3e1c840');
ChartsData.numberProp = ChartsData.entry.addProperty('017aafc16e3021850d6c');
ChartsData.colorProp = ChartsData.entry.addProperty('017aafc21ed458f7e971');

